import { useEffect, useState } from 'react';
import axios from 'axios';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { invField, money } from './invApi';

const Kpi = ({ label, value, testid }) => (
  <div className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-wider text-slate-500">{label}</p>
    <p className="text-xl font-bold text-white mt-1">{value}</p>
  </div>
);

const Breakdown = ({ title, data, testid }) => (
  <div className="bg-slate-900 border border-slate-800 rounded-xl p-4" data-testid={testid}>
    <p className="text-xs text-slate-400 mb-2">{title}</p>
    {Object.keys(data || {}).length === 0 && <p className="text-xs text-slate-600">Aucune donnée</p>}
    {Object.entries(data || {}).slice(0, 8).map(([k, v]) => (
      <div key={k} className="flex justify-between text-xs py-1 border-b border-slate-800/60 last:border-0"><span className="text-slate-300 truncate">{k}</span><span className="text-white">{money(v)}</span></div>
    ))}
  </div>
);

export const ReportTab = ({ api, token }) => {
  const [month, setMonth] = useState(() => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`; });
  const [rep, setRep] = useState(null);
  useEffect(() => { api.get('/report', { month }).then(setRep).catch(() => toast.error('Rapport indisponible')); }, [api, month]);

  const download = async () => {
    try {
      const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/inventory/report.csv`, { params: { month }, headers: { Authorization: `Bearer ${token}` }, responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url; a.download = `inventaire_${month}.csv`; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error('Téléchargement impossible'); }
  };

  return (
    <div className="space-y-4" data-testid="inventory-report-tab">
      <div className="flex flex-wrap items-center gap-3">
        <input type="month" className={`${invField} w-44`} value={month} onChange={e => setMonth(e.target.value)} data-testid="report-month" />
        <button onClick={download} className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-slate-700 text-sm text-slate-200 hover:border-amber-500/50" data-testid="report-csv"><Download size={14} /> Export pour le comptable (CSV)</button>
      </div>
      {rep && <>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <Kpi label="Valeur du stock (actuelle)" value={money(rep.stock_value)} testid="report-stock-value" />
          <Kpi label="Achats du mois" value={money(rep.purchases)} testid="report-purchases" />
          <Kpi label="Pièces utilisées (coûtant)" value={money(rep.used_cost)} testid="report-used" />
          <Kpi label="Ajustements" value={money(rep.adjustments)} testid="report-adjustments" />
        </div>
        {rep.parts_waiting_cost > 0 && <p className="text-xs text-amber-300" data-testid="report-waiting">{rep.parts_waiting_cost} pièce(s) utilisée(s) attendent leur facture fournisseur : leur coût sera ajouté à la réception.</p>}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-3">
          <Breakdown title="Stock par catégorie" data={rep.stock_value_by_category} testid="report-by-category" />
          <Breakdown title="Achats par fournisseur" data={rep.purchases_by_supplier} testid="report-by-supplier" />
          <Breakdown title="Utilisé par catégorie" data={rep.used_by_category} testid="report-used-category" />
          <Breakdown title="Utilisé par véhicule" data={rep.used_by_vehicle} testid="report-by-vehicle" />
        </div>
      </>}
    </div>
  );
};
